import React, { useState, useContext, useEffect, useRef } from "react";
import { useSpring, animated } from "react-spring";
import { useLocation, useParams } from "react-router-dom";
import { Editor, EditorState, RichUtils, convertFromRaw, convertToRaw, DefaultDraftBlockRenderMap, getDefaultKeyBinding, KeyBindingUtil,  } from "draft-js";
import { Bold, Check, Info, Italic, List, Plus, Underline } from "react-feather";


import { FormTextInput } from "../../Components/FormTextInput";
import { FormTextArea } from "../../Components/FormTextArea";

import { getQueryParam, useScreenTransition } from "../../Hooks/useScreenTransition";

import { AuthContext } from "../../Context/AuthContext";
import { TransitionContext } from "../../Context/TransitionContext";
import { NotificationContext } from "../../Context/NotificationContext";
import { DataContext } from "../../Context/DataContext";

import { languages } from "../../Data/languages";

import "./SingleOrder.css";
import { useReactToPrint } from "react-to-print";
import { InvoiceToPrint } from "../../Components/InvoicePrint";

import { v4 as uuidv4 } from 'uuid';
import { saveAs } from "file-saver";
import AccountNavBar from "../../NewComponents/AccountNavBar";
import NoData from "../../NewComponents/NoData";
import PopUpModal from "../../NewComponents/PopUpModal";
import SendPaymentLinkPopUp from "../../NewComponents/SendPaymentLinkPopUp";
import OrderSummary from "../Order/components/OrderSummary";
import SecureAndPrivate from "../../NewComponents/SecureAndPrivate";
import { ORDERSTATUS, REF_LABELS_COLORS, selectColor } from "../../Data/statuses";

import { ReactComponent as DOWNLOAD } from "../../assets/icons/Download.svg";
import { ReactComponent as LIKE } from "../../assets/icons/Like.svg";
import { ReactComponent as EMPTYSTAR } from "../../assets/icons/empty-star.svg";
import { ReactComponent as CHECK } from "../../assets/icons/CheckmarkСircleFill.svg";
import { ReactComponent as DELETE } from "../../assets/icons/delete.svg";
import { ReactComponent as CANCELORDER } from "../../assets/icons/cancel-order.svg";
import { ReactComponent as TRASH } from "../../assets/icons/Trash.svg";
import { ReactComponent as ORDERSUCCESS } from "../../assets/icons/order-success.svg";

import { ReactComponent as MORE } from "../../assets/icons/More.svg";
import { ReactComponent as MORESELECTED } from "../../assets/icons/More-selected.svg";
import { ReactComponent as BOLD } from "../../assets/Bold.svg";
import { ReactComponent as ITALIC } from "../../assets/Italic.svg";
import { ReactComponent as UNDERLINE } from "../../assets/UnderLine.svg";
import { ReactComponent as STRIKETHROUGH } from "../../assets/StrikeThrough.svg";
import { ReactComponent as NUMBERLIST } from "../../assets/NumberList.svg";
import { ReactComponent as BULLETEDLIST } from "../../assets/BulletedList.svg";
import { ReactComponent as ATTACHMENT } from "../../assets/Attachment.svg";
import { ReactComponent as Trash } from "../../assets/icons/Trash.svg";

import NewButton from "../../NewComponents/NewButton";
import {
  checkAutoBilling,
  decrTeamFreeExpedOrder,
  getDiscount,
  getExpedited,
  getTotal,
  updateInvoiceClientName,
} from "../../Data/Functions";
import OrderChatBox from "../../Components/OrderChatBox";
import AddCommentonDocument from "../../NewComponents/AddComment/AddCommentonDocument";
import AddCommentonTranslatedFiles from "../../NewComponents/AddComment/AddCommentonTranslatedFiles";
import { fieldValue, firestore, getFullHttpUrl, storage }from "../../firebase.config";
import axios from "axios";
import AddFilesAccountOrderPopUp from "../../NewComponents/AddFilesAccountOrderPopUp";
import RequestRevisionPopUp from "../../NewComponents/RequestRevisionPopUp";
import { FileUploaderButton } from "../../Components/FileUploaderButton";
import { AccountType } from "../../utility/enums";
import MessageDot from "../../NewComponents/MessageDot";
import { file } from "jszip";
import Loader from "../../NewComponents/Loader";
import { ReactComponent as Cross } from "../../assets/icons/CrossM.svg";
import OpenInvoiceModal from "../../NewComponents/OpenInvoiceModal";
import { sampleOrdersData } from "./OrdersComponents";
import { Map } from 'immutable';
import Tooltip from "../../Components/shared/tooltip/index.js";
import SignInForm from '../SignIn/SignInForm.js';
import CreateAccount from '../CreateAccount/CreateAccount.js';
import GetFileTypeElement from "../../Data/Functions/getFileType.js";

const SingleOrder = ({ windowSize }) => {
  const { setColor } = useContext(TransitionContext);
  const { showNotification } = useContext(NotificationContext);
  const { signedIn } = useContext(AuthContext);
  const { userData, teamData, order : localOrder, setOrder } = useContext(DataContext);
  const { transitionTo } = useScreenTransition();
  useEffect(() => {
    setColor(true);
  }, [setColor]);
  const { orderID } = useParams();
  const [orderInfo, setOrderInfo] = useState(null);
  const [loadedOrder, setLoadedOrder] = useState(false);
  const [selectedSendPayment, setSelectedSendPayment] = useState("");
  const [cancelBtnText, setCancelOrder] = useState("Cancel Order");
  const [approveBtnText, setApproveBtnText] = useState("Approve Translation");
  const [moreOptions, setMoreOptions] = useState(false);
  const [editReview, setEditReview] = useState(false);
  const [showCancelOrder, setShowCancelOrder] = useState(false);
  const [showApproveTranslation, setShowApproveTranslation] = useState(false);
  const [showReviewPopUp, setShowReviewPopUp] = useState(false);
  const [showStatusHoverBox, setShowStatusHoverBox] = useState(false);
  const [orderUpdated, setOrderUpdated] = useState(false);
  const [selectedTab, setSelectedTab] = useState(0);
  const [showRequestRevision, setShowRequestRevision] = useState(false);
  const [openRevision, setOpenRevision] = useState(false);
  const [openDisplayRevision, setOpenDisplayRevision] = useState(false)
  const revisionModalProps = useSpring({ opacity: openRevision ? 1 : 0, pointerEvents: openRevision ? 'all' : 'none' });
  const [clientRevisionNotes, setClientRevisionNotes] = React.useState(() => EditorState.createEmpty());
  const [files, setFiles] = useState([]);
  const [editorState, setEditorState] = React.useState(() => EditorState.createEmpty());
  const [supportReplyNotes, setSupportReplyNotes] = React.useState(() => EditorState.createEmpty());
  const [clientRevisionNotesFinal, setClientRevisionNotesFinal] = React.useState(() => EditorState.createEmpty());
  const [translatorNotesClient, setTranslatorNotesClient] = React.useState(() => EditorState.createEmpty());
  const [reviewRating, setReviewRating] = useState(0);
  const [saveReviewBtn, setSaveReviewBtn] = useState("Save");
  const [reviewText, setReviewText] = useState("");
  const [reviewSubmitButton, setReviewSubmitButton] = useState("Submit Review");
  const [teamUsers, setTeamUsers] = useState([]);
  const [newCCEmail, setNewCCEmail] = useState("");
  const [ccedEmails, setCCedEmails] = useState([]);
  const [addCCEmailBtnTxt, setAddCCEmailBtnTxt] = useState("Add");
  const [deleteBtnText, setDeleteBtnText] = useState("Delete");
  const [saveClientBtnTxt, setSaveClientBtnTxt] = useState("Save");
  const [showDeleteReview, setShowDeleteReview] = useState(false);
  const [clientFirstName, setClientFirstName] = useState("");
  const [clientLastName, setClientLastName] = useState("");
  const [sourceFiles, setSourceFiles] = useState([])
  const [showAddSourceFiles, setShowAddSourcefiles] = useState(false)
  const [addCommentFile, setAddCommentFile] = useState(null);
  const [addCommentTranslatedFile, setAddCommentonTranslatedFile] = useState(null);
  const [pagesCount, setPagesCount] = useState('');
  const [downloadOrder, setDownloadOrder] = useState('');
  const [openInvoiceModal, setOpenInvoiceModal] = useState();
  const [selectedPayment, setSelectedPayment] = useState();
  const [paylaterBtn, setPaylaterBtn] = useState("Pay Later");
  const [showDetailModal, setShowDetailModal] = useState(""); 
  const [isModalOpen, setIsModalOpen]=useState(false);
  const [isCreateAccountOpen, setIsCreateAccountOpen]=useState(false);
  const [isAttachment, setIsAttachment] = useState(false);
  const [isSubmittingRevisionRequest, setIsSubmittingRevisionRequest] = useState(false);
  const [isEditorFocused, setIsEditorFocused] = useState(false);
  const editorRef = useRef(null);
  const location = useLocation();

  const blockRenderMap = Map({
    'unordered-list-item': {
      element: 'li',
      wrapper: <ul />,
    },
    'ordered-list-item': {
      element: 'li',
      wrapper: <ol />,
    },
  }).merge(DefaultDraftBlockRenderMap)
  const currentStyle = clientRevisionNotes.getCurrentInlineStyle();
  const selection = clientRevisionNotes.getSelection();
  const blockType = clientRevisionNotes
    .getCurrentContent()
    .getBlockForKey(selection.getStartKey())
    .getType();

  const isEditorEmpty = !clientRevisionNotes.getCurrentContent().hasText();

  const hasEditorContent =
    isEditorEmpty &&
    blockType !== "unordered-list-item" &&
    blockType !== "ordered-list-item";

    const redirect_status = getQueryParam("redirect_status");
  
      useEffect(() => {
        if(redirect_status){
          if(redirect_status === "succeeded"){
            showNotification("Success", "Payment paid successfully.", "sucess")
          }else{
            showNotification("Error", "Payment failed, please try again.", "error")
          }
          // window.close();
        }
      }, redirect_status)


  const handleDownloadOrder = (order) => {
    setOpenInvoiceModal(order);
  }

  useEffect(() => {

    let unsub;
    if(orderID){

      if(orderID === "1234567890"){
        setOrderInfo(sampleOrdersData[0]);
        setLoadedOrder(true);
        return;
      }
      if(orderID === "1234567891"){
        setOrderInfo(sampleOrdersData[1]);
        setLoadedOrder(true);
        return;
      }
      if(orderID === "1234567892"){
        setOrderInfo(sampleOrdersData[2]);
        setLoadedOrder(true);
        return;
      }
      
      unsub = firestore
        .collection("orders")
        .doc(orderID)
        .onSnapshot(
          (doc) => {
            if (doc.exists) {
              setOrderInfo({ ...doc.data(), id: doc.id });

              if (doc.data().teamId && doc.data().ccedEmails) {
                setCCedEmails(doc.data().ccedEmails);
              }
              if (doc.data().supportReply) {
                setSupportReplyNotes(EditorState.createWithContent(convertFromRaw(doc.data().supportReply)))
              }

              if (doc.data().clientRevisionNotes) {
                setClientRevisionNotes(EditorState.createWithContent(convertFromRaw(doc.data().clientRevisionNotes)))
                setClientRevisionNotesFinal(EditorState.createWithContent(convertFromRaw(doc.data().clientRevisionNotes)))
              }

              if (doc.data().translatorNotesClient) {
                setTranslatorNotesClient(EditorState.createWithContent(convertFromRaw(doc.data().translatorNotesClient)))
              }

              if (doc.data().notes && doc.data().notes.blocks) {
                setEditorState(
                  EditorState.createWithContent(convertFromRaw(doc.data().notes))
                );
              }



              if (doc.data().supportReply) {
                setSupportReplyNotes(EditorState.createWithContent(convertFromRaw(doc.data().supportReply)))
              }

              if (doc.data().clientRevisionNotes) {
                setClientRevisionNotes(EditorState.createWithContent(convertFromRaw(doc.data().clientRevisionNotes)));
              }

              if (doc.data().translatorNotesClient) {
                setTranslatorNotesClient(EditorState.createWithContent(convertFromRaw(doc.data().translatorNotesClient)))
              }
              if (doc.data().teamId && doc.data().clientFirstName) {
                setClientFirstName(doc.data().clientFirstName);
                setClientLastName(doc.data().clientLastName);
              }

              if (doc.data().notes && doc.data().notes.blocks) {
                setEditorState(
                  EditorState.createWithContent(convertFromRaw(doc.data().notes))
                );
              }

              if (
                !doc.data().shownConfirmation &&
                doc.data().status !== "created"
              ) {
                firestore
                  .collection("orders")
                  .doc(orderID)
                  .update({ shownConfirmation: true });
              }
              setLoadedOrder(true);
            } else {
              transitionTo("/");
              // console.log("error");
              // showNotification(
              //   "Error",
              //   "An error ocurred loading the order info. Try again. If it persists, please contact Support.",
              //   "error"
              // );
            }
          },
          (error) => {
            transitionTo("/")
            // showNotification(
            //   "Error",
            //   "An error ocurred loading the order info. Try again. If it persists, please contact Support.",
            //   "error"
            // );
          }
        );
      }

      return () => unsub && unsub();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderID, orderUpdated]);

  useEffect(() => {
    if (userData && userData.teamId && orderInfo && orderInfo.teamId) {

      firestore
        .collection("users")
        .where("teamId", "==", orderInfo.teamId)
        .where("email", "!=", orderInfo.email)
        .orderBy("email", "asc")
        .get()
        .then((querySnap) => {
          setTeamUsers(
            querySnap.docs.map((doc) => {
              return { id: doc.id, ...doc.data() };
            })
          );
        });
    }
  }, [orderInfo, userData]);

  useEffect(() => {
    if (openRevision && editorRef.current) {
      setTimeout(() => {
        editorRef.current.focus();
      }, 50);
    }
  }, [openRevision]);

  const formatDate = (timestamp) => {
    if (String(timestamp).length === 10) {
      timestamp *= 1000;
    }
    const date = new Date(timestamp);
    const options = { month: "short", day: "2-digit", year: "numeric" };
    const formattedDate = date.toLocaleDateString("en-US", options);
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    return `${formattedDate} @${String(hours).padStart(2, "0")}:${minutes} ${ampm}`;
  };
  const getLanguage = (language) => {
    if (languages.find((lang) => lang.value === language)) {
      return languages.find((lang) => lang.value === language).label;
    } else {
      return "";
    }
  };

  const downloadFile = url => {
    window.open(url, '_blank')
}

 
  const handleApproveTranslation = () => {
    setApproveBtnText("Approving...");

    const now = new Date();

    firestore
      .collection("orders")
      .doc(orderInfo.id)
      .update({
        status: "completed",
        clientApproved: true,
        completed: now.getTime(),
        notarizationStatus: "queue",
        hardCopyStatus: "queue",
      })
      .then(() => {
        setShowApproveTranslation(false);
        setApproveBtnText("Approve Translation");
        setShowReviewPopUp(true);
        showNotification(
          "Success",
          "The order has been successfully approved.",
          "success"
        );
      })
      .catch(() => {
        setApproveBtnText("Approve Translation");
        showNotification(
          "Error",
          "An error ocurred approving the order. Please, try again. If it persists, contact Support.",
          "error"
        );
      });
  };

  const handleDeleteReview = async () => {
    setDeleteBtnText("Deleting...");


    firestore
      .collection("orders")
      .doc(orderInfo.id)
      .update({
        reviewRating: null,
        reviewText: null,
      })
      .then(() => {
        firestore
          .collection("reviews")
          .where("orderID", "==", orderInfo.id)
          .get()
          .then((querySnap) => {
            if (querySnap.empty) {
              return;
            } else {
              firestore
                .collection("reviews")
                .doc(querySnap.docs[0].id)
                .delete()
                .then(() => {
                  showNotification(
                    "Success",
                    "Review deleted successfully.",
                    "success"
                  );
                  setMoreOptions(false);
                  setDeleteBtnText("Delete");
                  setShowDeleteReview(false);
                  setReviewText("");
                  setReviewRating(0);
                  setOrderUpdated((o) => !o);
                })
                .catch((error) => {
                  setDeleteBtnText("Delete");
                  showNotification(
                    "Error",
                    "An error ocurred while deleting the review. Please, try again.",
                    "error"
                  );
                });
            }
          });
      })
      .catch((error) => {
        setDeleteBtnText("Delete");
        showNotification(
          "Error",
          "An error ocurred while deleting the review. Please, try again.",
          "error"
        );
      });
  };

  const handleSubmitReview = async () => {
    setReviewSubmitButton("Submitting...");

    const now = new Date();

    firestore
      .collection("orders")
      .doc(orderInfo.id)
      .update({
        reviewRating:
          reviewRating.toString().length === 1
            ? reviewRating.toString() + ".0"
            : reviewRating.toString(),
        reviewText: reviewText,
      })
      .then(() => {
        firestore
          .collection("reviews")
          .add({
            orderID: orderInfo.id,
            userID: userData.id,
            name: orderInfo.name,
            languageFrom: getLanguage(orderInfo.languageFrom),
            languageTo: getLanguage(orderInfo.languageTo),
            score:
              reviewRating.toString().length === 1
                ? reviewRating.toString() + ".0"
                : reviewRating.toString(),
            text: reviewText,
            date: now.getTime(),
            email: orderInfo.email,
          })
          .then(() => {
            showNotification(
              "Success",
              "Thanks for leaving a review!.",
              "success"
            );
            setReviewSubmitButton("Submit Review");
            setShowReviewPopUp(false);
            setOrderUpdated((o) => !o);
          })
          .catch((error) => {
            showNotification(
              "Error",
              "An error ocurred while submitting the review. Please, try again.",
              "error"
            );
            setReviewSubmitButton("Submit Review");
          });
      })
      .catch((error) => {
        showNotification(
          "Error",
          "An error ocurred while submitting the review. Please, try again.",
          "error"
        );
        setReviewSubmitButton("Submit Review");
      });
  };
  const saveNotes = () => {

    firestore.collection('orders').doc(orderInfo.id)
      .update({
        notes: convertToRaw(editorState.getCurrentContent()),
      })
      .then(() => {
        showNotification('Success', "Notes have been successfully saved.", 'success');
      })
      .catch(error => {
        //console.log(error);
        showNotification('Error', "An error ocurred while saving the notes. Please, try again.", 'error');
      })
  }
  const handleUpdateReview = async () => {
    setSaveReviewBtn("Saving...");

    const now = new Date();

    firestore
      .collection("orders")
      .doc(orderInfo.id)
      .update({
        reviewRating:
          reviewRating.toString().length === 1
            ? reviewRating.toString() + ".0"
            : reviewRating.toString(),
        reviewText: reviewText,
      })
      .then(() => {
        firestore
          .collection("reviews")
          .where("orderID", "==", orderInfo.id)
          .get()
          .then((querySnap) => {
            if (querySnap.empty) {
              return;
            } else {
              firestore
                .collection("reviews")
                .doc(querySnap.docs[0].id)
                .update({
                  score:
                    reviewRating.toString().length === 1
                      ? reviewRating.toString() + ".0"
                      : reviewRating.toString(),
                  text: reviewText,
                  date: now.getTime(),
                })
                .then(() => {
                  showNotification(
                    "Success",
                    "Thanks for leaving a review!.",
                    "success"
                  );
                  setSaveReviewBtn("Save");
                  setEditReview(false);
                  setOrderUpdated((o) => !o);
                })
                .catch((error) => {
                  showNotification(
                    "Error",
                    "An error ocurred while updating the review. Please, try again.",
                    "error"
                  );
                  setSaveReviewBtn("Save");
                });
            }
          });
      })
      .catch((error) => {
        showNotification(
          "Error",
          "An error ocurred while updating the review. Please, try again.",
          "error"
        );
        setSaveReviewBtn("Save");
      });
  };

  const updateClientsName = () => {

    firestore
      .collection("clients")
      .where("name", "==", clientFirstName + " " + clientLastName)
      .where("teamId", "==", userData.teamId)
      .get()
      .then((qSnap) => {
        if (!qSnap.empty) {
          qSnap.docs.forEach((doc) => {
            firestore
              .collection("clients")
              .doc(doc.id)
              .update({
                orderCount: doc.data().orderCount + 1,
              })
              .catch((error) => {
                showNotification(
                  "Error",
                  "An error ocurred while saving client name. Please, try again.",
                  "error"
                );
                setSaveClientBtnTxt("Save");
              });
          });
        } else {
          firestore
            .collection("clients")
            .add({
              orderCount: 1,
              fistName: clientFirstName,
              lastName: clientLastName,
              name: clientFirstName + " " + clientLastName,
              teamId: userData.teamId,
            })
            .catch((error) => {
              showNotification(
                "Error",
                "An error ocurred while saving client name. Please, try again.",
                "error"
              );
              setSaveClientBtnTxt("Save");
            });
        }
      })
      .catch((error) => {
        showNotification(
          "Error",
          "An error ocurred while saving client name. Please, try again.",
          "error"
        );
        setSaveClientBtnTxt("Save");
      });
  };

  const handleSaveClientName = async () => {
    if (clientFirstName === "") {
      showNotification(
        "Error",
        "Empty Client Name, please enter a client name.",
        "error"
      );
      return;
    }
    setSaveClientBtnTxt("Saving...");

    firestore
      .collection("orders")
      .doc(orderInfo.id)
      .update({
        clientFirstName: clientFirstName,
        clientLastName: clientLastName,
      })
      .then(async () => {
        // updateClientsName();
        await updateInvoiceClientName(orderInfo, clientFirstName, clientLastName);
        showNotification(
          "Client Saved",
          "Your client has been saved successfully.",
          "success"
        );
      })
      .catch((error) => {
        showNotification(
          "Error",
          "An error ocurred while saving client name. Please, try again.",
          "error"
        );
        setSaveClientBtnTxt("Save");
      })
      .finally(() => {
        setSaveClientBtnTxt("Save");
        setOrderUpdated((o) => !o);
      });
  };

  const addCCedEmail = (email) => {
    if (addCCEmailBtnTxt === "Adding..") {
      return;
    }

    const emailRegex = new RegExp(
      "^[a-zA-Z0-9._+%-]+@[a-zA-Z0-9-]+\\.[a-zA-Z]{2,}(\\.?[a-z]{2})?$"
    );
    const lowerCaseEmail = email.toLowerCase();
    // let EmailMatched = false;

    if (email === "" || !emailRegex.test(lowerCaseEmail)) {
      showNotification(
        "Error",
        "Invalid Email, please enter valid email.",
        "error"
      );
      return;
    }
    setAddCCEmailBtnTxt("Adding..");

    // teamUsers.forEach(user => {
    //   if(user.email === lowerCaseEmail){
    //     EmailMatched = true;
    //     return;
    //   }
    // })

    if (
      (ccedEmails.length > 0 && ccedEmails.includes(lowerCaseEmail)) ||
      orderInfo.email === lowerCaseEmail
    ) {
      showNotification(
        "Error",
        "Email already exist, please enter another email.",
        "error"
      );
      return;
    }
    firestore
      .collection("orders")
      .doc(orderID)
      .update({
        ccedEmails: [...ccedEmails, lowerCaseEmail],
      })
      .then(() => {
        setOrderUpdated((o) => !o);
      })
      .catch((e) => {
        showNotification("Error", "Error occured please try again", "error");
      });
    setNewCCEmail("");
    setAddCCEmailBtnTxt("Add");
    showNotification("Email added", "Email added successfully.", "success");
  };

  const removeCCedEmail = (email) => {

    firestore
      .collection("orders")
      .doc(orderID)
      .update({
        ccedEmails: ccedEmails.filter((e) => e !== email),
      })
      .catch((e) => {
        showNotification("Error", "Error occured please try again", "error");
      });
  };

  const getFullAddress = (address) => {
    const parts = [
      address.firstName && address.firstName !== "Undefined"
        ? address.firstName || address.recipient
        : "",
      address.lastName && address.lastName !== "Undefined"
        ? address.lastName
        : "",
      address.country && address.country !== "Undefined" ? address.country : "",
      address.region && address.region !== "Undefined" ? address.region : "",
      address.city && address.city !== "Undefined" ? address.city : "",
      address.zipCode && address.zipCode !== "Undefined" ? address.zipCode : "",
      address.street && address.street !== "Undefined" ? address.street : "",
      address.apartment && address.apartment !== "Undefined"
        ? address.apartment
        : "",
    ].filter(Boolean);

    return parts.join(", ");
  };

  const handleCancelOrder = (isPaid) => {
    setCancelOrder("Cancelling...");

    firestore
      .collection("orders")
      .doc(orderID)
      .update({
        status: isPaid ? "on-hold" :
          orderInfo.status === "new" || orderInfo.status === "draft"
            ? "cancelled"
            :  "on-hold",
          cancellationHold: isPaid ? true:
          orderInfo.status === "new" || orderInfo.status === "draft"
            ? false
            :  true
      })
      .then(() => {
        setCancelOrder("Cancel");
        setShowCancelOrder(false);
        setOrderUpdated((o) => !o);
      })
      .catch((e) => {
        setCancelOrder("Cancelling...");
        showNotification(
          "Error",
          "Error occured cancelling the order please try again",
          "error"
        );
      });
  };


  const handleSourceFiles = async (e) => {
    const now = new Date();

    const mFiles = e.target.files;

    const oID = orderInfo.id;

    for (let i = 0; i < mFiles.length; i++) {
      const fileID = uuidv4();
      setSourceFiles(f => f.concat([{ id: fileID, name: mFiles[i].name, file: mFiles[i], progress: 0, status: 'uploading' }]));
    }

    const storageRef = storage.ref();

    for (let i = 0; i < mFiles.length; i++) {
      const subFolder = uuidv4();
      const fileRef = storageRef.child(oID + '/' + subFolder + '/' + mFiles[i].name);

      const downloadToken = uuidv4();

      const fileName = mFiles[i].name.replace('#', '%23').replace('+', "%2b");

      const url = `${process.env.REACT_APP_STORAGE_URL}/o/${oID}%2F${subFolder}%2F${fileName}?alt=media&token=${downloadToken}`;

      var metadata = {
        firebaseStorageDownloadTokens: downloadToken,
        customMetadata: {
          'orderID': oID
        }
      }

      const uploadTask = fileRef.put(mFiles[i], metadata);

      setSourceFiles(f => f.map(file => file.name === mFiles[i].name && file.ref === mFiles[i].ref ? { ...file, task: uploadTask } : file));

      uploadTask.on('state_changed', (snapshot) => {
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setSourceFiles(f => f.map(file => file.name === mFiles[i].name && file.ref === mFiles[i].ref ? { ...file, progress: progress.toFixed(2) } : file));
      }, (error) => {
        // setSourceFiles(f => f.map(file => file.name === mFiles[i].name && file.ref === mFiles[i].ref ? { ...file, status: 'failed' } : file));
        setSourceFiles(f => f.filter(file => file.name !== mFiles[i].name && file.ref !== mFiles[i].ref));
        showNotification("Error uploading.", "There was an error uploading the file " + mFiles[i].name + ". Please, try again.", "error");
      }, () => {
        setSourceFiles(f => f.map(file => file.name === mFiles[i].name && file.ref === mFiles[i].ref ? { ...file, status: 'complete', ref: oID + '/' + subFolder + '/' + mFiles[i].name, url: url, timestamp: now.getTime() } : file));
      });
    }

  }
  const handleDeleteSourceFile = async (file, notify = true) => {
    const checkFile = (file1, file2) => {
      if(file1.id && file2.id){
        return file1.id === file2.id;
      }
      if(file1.ref && file2.ref){
        return file1.ref === file2.ref;
      }
    }
    if (file.ref && (file.status === "complete" || file.timestamp)) {
      try {
        const storageRef = storage.ref();
        const fileRef = storageRef.child(file.ref);
  
        setSourceFiles((prevFiles) =>
          prevFiles.map((mFile) =>
            checkFile(mFile, file) ? { ...mFile, status: "deleting" } : mFile
          )
        );
  
  
        await fileRef.delete();
  
        setSourceFiles((prevFiles) => prevFiles.filter((mFile) => !checkFile(mFile, file)));
  
        if (notify) {
          showNotification("Success", "File deleted successfully.", "success");
        }
      } catch (error) {
        console.error("Delete error:", error);
        if (notify) {
          showNotification("Delete Error", "Failed to delete file. Please try again.", "error");
        }
           setSourceFiles((prevFiles) =>
             prevFiles.map((mFile) =>
               checkFile(mFile, file) ? { ...mFile, status: "complete" } : mFile
             )
           );
         }
      }else if (file.status === 'failed') {
        setSourceFiles((prevFiles) => prevFiles.filter((mFile) => !checkFile(mFile, file)));
      } else {
         file.task.cancel();
        setSourceFiles((prevFiles) => prevFiles.filter((mFile) => !checkFile(mFile, file)));
      }
  };
  const CancelAddSourceFiles = () => {
    setShowAddSourcefiles(false)
    handleSourceFiles([]);
  }
  const CancelRequestRevision = () => {
    setShowRequestRevision(false)
    // handleSourceFiles([]);
  }
  const handleSubmitSourceFiles = async () => {
    const files = sourceFiles
      ?.filter((f) => f.ref && f.url && f.status === "complete")
      .map((file) => ({
        name: file.name,
        ref: file.ref,
        url: file.url,
        type: "source",
        size: file.file ? file.file.size : file.size,
        format: file.file ? file.file.type : file.format,
        timestamp: file.timestamp,
      }));

    if (!files.length) {
      showNotification("Warning", "No valid files to upload.", "warning");
      return;
    }

    const orderRef = firestore.collection("orders").doc(orderID);

    try {
      await orderRef.update({
        files: fieldValue.arrayUnion(...files),
        pagesCount: (Number(orderInfo.pagesCount) || 0) + Number(pagesCount),
      });
      setShowAddSourcefiles(false)
      showNotification("Success", "Files successfully added to the order.", "success");
      setSourceFiles([])
    } catch (error) {
      showNotification("Error", "Failed to update order with files.", "error");
      console.error("Error updating order with files:", error);
    }
  };

  const updateStatusToRevision = async () => {
    try {

      if (orderInfo?.id) {
        const orderRef = firestore.collection("orders").doc(orderInfo.id);
        await orderRef.update({
          status: "revision"
        });

        showNotification("Success", "Request for revision has been send successfully.", "success");

      }
    } catch (error) {
      showNotification("Error", `Failed to update Request revision: ${error.message}`, "error");
    }
    setShowRequestRevision(false);
  };
  const onChangePagesCount = (count) => {
    var reg = /^[0-9]+\.?[0-9]{0,3}$/;

    if (count === '' || reg.test(count)) {
      setPagesCount(count);
    }
  }
  const handleBoldClick = revision => {
    if (editorRef.current) {
      editorRef.current.focus();
    }
    if (revision) {
      setClientRevisionNotes(editorState => RichUtils.toggleInlineStyle(editorState, 'BOLD'))
    } else {
      setEditorState(editorState => RichUtils.toggleInlineStyle(editorState, 'BOLD'))
    }
  }

  const handleItalicClick = revision => {
    if (editorRef.current) {
      editorRef.current.focus();
    }
    if (revision) {
      setClientRevisionNotes(editorState => RichUtils.toggleInlineStyle(editorState, 'ITALIC'))
    } else {
      setEditorState(editorState => RichUtils.toggleInlineStyle(editorState, 'ITALIC'))
    }
  }

  const handleUnderlineClick = revision => {
    if (editorRef.current) {
      editorRef.current.focus();
    }
    if (revision) {
      setClientRevisionNotes(editorState => RichUtils.toggleInlineStyle(editorState, 'UNDERLINE'))
    } else {
      setEditorState(editorState => RichUtils.toggleInlineStyle(editorState, 'UNDERLINE'))
    }
  }

  const toggleUL = revision => {
    if (editorRef.current) {
      editorRef.current.focus();
    }
    if (revision) {
      setClientRevisionNotes(editorState => RichUtils.toggleBlockType(editorState, 'unordered-list-item'))
    } else {
      setEditorState(editorState => RichUtils.toggleBlockType(editorState, 'unordered-list-item'))
    }
  }

  const handleStrikethroughClick = revision => {
    if (editorRef.current) {
      editorRef.current.focus();
    }
    if (revision) {
      setClientRevisionNotes(editorState =>
        RichUtils.toggleInlineStyle(editorState, 'STRIKETHROUGH')
      )
    } else {
      setEditorState(editorState =>
        RichUtils.toggleInlineStyle(editorState, 'STRIKETHROUGH')
      )
    }
  }

  const toggleOL = revision => {
    if (editorRef.current) {
      editorRef.current.focus();
    }
    if (revision) {
      setClientRevisionNotes(editorState =>
        RichUtils.toggleBlockType(editorState, 'ordered-list-item')
      )
    } else {
      setEditorState(editorState =>
        RichUtils.toggleBlockType(editorState, 'ordered-list-item')
      )
    }
  }

  const handleFiles = async (e) => {
        const mFiles = e.target.files;
    
        const oID = orderInfo.id;
    
        for (let i = 0; i < mFiles.length; i++) {
          const fileID = uuidv4();
          setFiles(f => f.concat([{ id: fileID, name: mFiles[i].name, file: mFiles[i], progress: 0, status: 'uploading', error: null }]));
        }
    
        const storageRef = storage.ref();
    
        for (let i = 0; i < mFiles.length; i++) {
          const subFolder = uuidv4();
          const fileRef = storageRef.child(oID + '/' + subFolder + '/' + mFiles[i].name);
    
          const downloadToken = uuidv4();
    
          const fileName = mFiles[i].name.replace('#', '%23').replace('+', "%2b");
    
          const url = `${process.env.REACT_APP_STORAGE_URL}/o/${oID}%2F${subFolder}%2F${fileName}?alt=media&token=${downloadToken}`;
    
          var metadata = {
            firebaseStorageDownloadTokens: downloadToken,
            customMetadata: {
              'orderID': oID
            }
          }
    
          const uploadTask = fileRef.put(mFiles[i], metadata);
    
          setFiles(f => f.map(file => file.name === mFiles[i].name && file.ref === mFiles[i].ref ? { ...file, task: uploadTask } : file));
    
          uploadTask.on('state_changed', (snapshot) => {
            const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            setFiles(f => f.map(file => file.name === mFiles[i].name && file.ref === mFiles[i].ref ? { ...file, progress: progress.toFixed(2) } : file));
          }, (error) => {
            setFiles(f => f.map(file => file.name === mFiles[i].name && file.ref === mFiles[i].ref ? { ...file, status: 'failed', error: error?.message } : file));
            setFiles(f => f.filter(file => file.name !== mFiles[i].name && file.ref !== mFiles[i].ref));
            showNotification("Error uploading.", "There was an error uploading the file " + mFiles[i].name + ". Please, try again.", "error");
          }, () => {
            setFiles(f => f.map(file => file.name === mFiles[i].name && file.ref === mFiles[i].ref ? { ...file, status: 'complete', ref: oID + '/' + subFolder + '/' + mFiles[i].name, url: url, timestamp: new Date().getTime(), error: null } : file));
          });
        }
    
      }

      const handleDeleteFile = async(file) => {
        const checkFile = (file1, file2) => {
          if(file1.id && file2.id){
            return file1.id === file2.id;
          }
          if(file1.ref && file2.ref){
            return file1.ref === file2.ref;
          }
        }
        const storageRef = storage.ref();
    
        if (file.ref && (file.status === "complete" || file.timestamp)) {
          const fileRef = storageRef.child(file.ref);
          setFiles((f) =>
            f.map((mFile) =>
              mFile.name === file.name && checkFile(mFile, file)
                ? { ...mFile, status: "deleting" }
                : mFile
            )
          );
    
          await fileRef
            .delete()
            .then(function () {
              setFiles((f) => f.filter((mFile) => !checkFile(mFile, file)));
              showNotification("Success", "File deleted successfully.", "success");
            })
            .catch(function (error) {
              showNotification(
                "Error deleting the file.",
                "There was an error deleting the file " +
                  file.name +
                  ". Please, try again.",
                "error"
              );
            });
        } else if (file.status === "failed") {
          setFiles((f) => f.filter((mFile) => !checkFile(mFile, file)));
        } else {
          file.task.cancel();
          setFiles((f) => f.filter((mFile) => !checkFile(mFile, file)));
        }
      };


  const submitRevisionRequest = () => {

    const localFiles = files.map(f => f);

    const now = new Date();
    setIsSubmittingRevisionRequest(true);
    firestore.collection('orders').doc(orderInfo.id)
      .update({
        files: orderInfo.files.concat(localFiles.map(f => ({ name: f.name, ref: f.ref, url: f.url, type: 'revision', size: f.file.size, format: f.file.type, timestamp: (new Date()).getTime() }))),
        clientRevisionNotes: convertToRaw(clientRevisionNotes.getCurrentContent()),
        status: 'revision',
        clientApproved: false,
        revision: true,
        revisionAssigned: now.getTime(),
        revisionDue: now.getTime() + 43200000,
        revisionOverdue: false,
        userRevisionRequested: true
      })
      .then(() => {
        showNotification("Success", "The revision request has been successfully submitted.", "success");
        setOpenRevision(false);
        setFiles([]);
        setIsSubmittingRevisionRequest(false);
      })
      .catch(error => {
        setFiles(localFiles);
        setIsSubmittingRevisionRequest(false);
        showNotification("Error", "There was an error submitting the revision. Please, try again.", "error");
      })
  }

  const handlePlaceOrder = async (orderData, paypalID) => {

    setPaylaterBtn("Placing Order...");


    await firestore
      .collection("orders")
      .doc(orderData.id)
      .update({
        paypalOrderID: paypalID,
        status: "new",
      })
      .then(() => {
        setPaylaterBtn("Pay Later");
        setSelectedPayment("");
        if(orderData.expedited || orderData.expeditedPlus){
          decrTeamFreeExpedOrder(orderData.teamId);
        }

        if(localOrder.orderNumber === orderData.orderNumber){
          localStorage.setItem(
            "order",
            JSON.stringify({ orderID: "", name: "", email: "", parsed: true })
          );
          setOrder({ orderID: "", name: "", email: "", parsed: true });
        }
      })
      .catch((error) => {
        setPaylaterBtn("Pay Later");
        showNotification(
          "Error",
          "An error ocurred while finishing the order. Please, try again.",
          "error"
        );
      });
  };


  const handleLoginOpen=(newState)=>{
    setIsModalOpen(newState);
  }

  const handleCreateAccountOpen=(newState)=>{
    setIsCreateAccountOpen(newState);
  }
  useEffect(() => {
    if (openRevision || openDisplayRevision) {
      // document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [openRevision, openDisplayRevision]);
  
  const isUploading = files.some(file => file.status === "uploading" || file?.file?.error);
  const isDisabled = isUploading || (isEditorEmpty && files.length === 0) || isSubmittingRevisionRequest;

  const keyBindingFn = (e) => {
    if (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === "x") {
      return "strikethrough";
    }

    if (e.ctrlKey && e.shiftKey && e.key === "7" || e.key === "*") {
      return "myapp-ordered-list";
    }

    if (e.ctrlKey && e.shiftKey && e.key === "8" || e.key === "&") {
      return "myapp-unordered-list";
    }

    return getDefaultKeyBinding(e);
  };

  const handleKeyCommand = (command, editorState) => {
    let newState = null;

    switch (command) {
      case "strikethrough":
        newState = RichUtils.toggleInlineStyle(editorState, "STRIKETHROUGH");
        break;

      case "myapp-ordered-list":
        newState = RichUtils.toggleBlockType(editorState, "ordered-list-item");
        break;

      case "myapp-unordered-list":
        newState = RichUtils.toggleBlockType(editorState, "unordered-list-item");
        break;

      default:
        newState = RichUtils.handleKeyCommand(editorState, command);
    }

    if (newState) {
      setClientRevisionNotes(newState);
      return "handled";
    }

    return "not-handled";
  };

   if (!loadedOrder) {
      return (
        <div className="container mx-auto w-full h-dvh flex items-center justify-center">
          <Loader />
        </div>
      );
    }

  return (
    <>
    <SignInForm
        open={isModalOpen}
        isLoginFormOpen={handleLoginOpen}
        isCreateAccountOpen={handleCreateAccountOpen}
        pageRedirect={false}
    />
    <CreateAccount
        open={isCreateAccountOpen}
        isCreateAccountOpen={handleCreateAccountOpen}
        isLoginFormOpen={handleLoginOpen}
    />

    {openInvoiceModal && <OpenInvoiceModal type="order" order={openInvoiceModal} onClose={() => setOpenInvoiceModal(null)}/>}

    {selectedPayment && (
        <PopUpModal
          title={"Place Order"}
          backBtnText={paylaterBtn}
          subText={"Order Number: #"+selectedPayment.orderNumber}
          text={"Do you want to pay for this order now or later?"}
          btnText={"Pay Now"}
          hideIcon
          showClose
          onClose={() => setSelectedPayment("")}
          onClick={(e) =>
            transitionTo(`/make-payment/order/${selectedPayment.id}`, e)
          }
          onBackClick={() => {
            handlePlaceOrder(selectedPayment, "pay-later");
          }}
          disableBtn={paylaterBtn === "Placing Order..."}
        ></PopUpModal>
      )}
      

      {addCommentFile ? (
        <AddCommentonDocument
          selectedFile={addCommentFile}
          orderInfo={orderInfo}
          handleClose={() => setAddCommentFile(null)}

        />
      ) : addCommentTranslatedFile ? (
        <AddCommentonTranslatedFiles
          selectedFile={addCommentTranslatedFile}
          orderInfo={orderInfo}
          handleClose={() => setAddCommentonTranslatedFile(null)}
          userData={userData}

        />
      ) : (
        <>
          {showDeleteReview && (
            <PopUpModal
              title={"Delete Review"}
              backBtnText="Cancel"
              subText=""
              text={"Are you sure you want to delete your review?"}
              btnText={deleteBtnText}
              iconBgColor="#FFF6EA"
              deleteBtn={true}
              showClose
              onClose={() => setShowDeleteReview(false)}
              onClick={() => handleDeleteReview()}
              onBackClick={() => {
                setShowDeleteReview(false);
              }}
              disableBtn={deleteBtnText === "Deleting..."}
            >
              <DELETE />
            </PopUpModal>
          )}


          {showCancelOrder && (
            <PopUpModal
              title={"Cancel Order"}
              backBtnText="Back to Order"
              subText="Are you sure you want to cancel this order?"
              text={(orderInfo.orderNumber)}
              btnText={cancelBtnText}
              iconBgColor="#FFF6EA"
              deleteBtn={true}
              showClose
              onClose={() => setShowCancelOrder(false)}
              onClick={() => handleCancelOrder(orderInfo.paypalOrderID !== "auto-billing" && orderInfo.paypalOrderID !== "pay-later")}
              onBackClick={() => {
                setShowCancelOrder(false);
              }}
              disableBtn={cancelBtnText === "Cancelling..."}
              warningText={
                (orderInfo.status === "in-progress" ||
                  orderInfo.status === "assigned" || (orderInfo.paypalOrderID !== "auto-billing" && orderInfo.paypalOrderID !== "pay-later")) &&
                "Your order will be placed 'on Hold'. If the translator has started working on the translation, we’d reach you to confirm the cancellation details. You may be charged for the percentage of the translation work done."
              }
            >
              <CANCELORDER />
            </PopUpModal>
          )}
          {showApproveTranslation && (
            <PopUpModal
              title={"Approve Translation"}
              backBtnText="Cancel"
              text="If you ordered notarization or hard copies, your approval is required before we can proceed with fulfillment. You can also leave a review after approving."
              subText={""}
              btnText={approveBtnText}
              hideIcon
              alignLeft
              showClose
              onClose={() => setShowApproveTranslation(false)}
              onClick={() => handleApproveTranslation()}
              onBackClick={() => {
                setShowApproveTranslation(false);
              }}
              disableBtn={approveBtnText === "Approving..."}
            ></PopUpModal>
          )}

          {showReviewPopUp && (
            <PopUpModal
              title={"Order Successfully Approved"}
              backBtnText="Skip"
              text=""
              subText={
                "Please, rate the quality of the translation, additional services and communication with the interpreter, if any. If you don't have the time now you can leave a review on the order page later."
              }
              btnText={reviewSubmitButton}
              iconBgColor="#E6FAF2"
              alignLeft
              showClose
              onClose={() => setShowReviewPopUp(false)}
              onClick={() => handleSubmitReview()}
              onBackClick={() => {
                setShowReviewPopUp(false);
              }}
              disableBtn={
                reviewRating === 0 || reviewSubmitButton === "Submitting..."
              }
              showReview
              reviewRating={reviewRating}
              setReviewRating={setReviewRating}
              reviewText={reviewText}
              setReviewText={setReviewText}
            >
              <ORDERSUCCESS />
            </PopUpModal>
          )}

          {showAddSourceFiles && (
            <AddFilesAccountOrderPopUp windowSize={windowSize} onCancel={CancelAddSourceFiles} pagesCount={pagesCount} onChangePagesCount={onChangePagesCount} files={sourceFiles} handleFiles={handleSourceFiles} handleDeleteFile={handleDeleteSourceFile} onClose={() => setShowAddSourcefiles(false)} onSave={handleSubmitSourceFiles} />
          )}

          {showRequestRevision && (
            <RequestRevisionPopUp windowSize={windowSize} userData={userData} onCancel={CancelRequestRevision} files={sourceFiles} handleFiles={handleSourceFiles} handleDeleteFile={handleDeleteSourceFile} onClose={() => setShowRequestRevision(false)} onSave={updateStatusToRevision} />
          )}
          {selectedSendPayment !== "" && (
            <SendPaymentLinkPopUp
              data={selectedSendPayment}
              type={selectedSendPayment.orderInvoiceId && selectedSendPayment.status !== "created" ? "invoice" : "order"}
              id={selectedSendPayment.orderInvoiceId && selectedSendPayment.status !== "created" ? selectedSendPayment.orderInvoiceId : selectedSendPayment.id}
              onClose={() => setSelectedSendPayment("")}
            />
          )}
          {openRevision && (
            <div
              style={revisionModalProps}
              className="orderRevisionModalBg"
              onClick={() => setOpenRevision(false)}
            >
              <div
                style={revisionModalProps}
                className="orderRevisionModalOuter"
                onClick={(e) => e.stopPropagation()}
              >
                <div 
                  role="modal-container" 
                  className="customScroll flex flex-col gap-5 w-full" 
                  style={{
                    overflowY: files.length > 2 ? 'auto' : 'visible',
                    maxHeight: files.length > 2 ? '47vh' : '',
                  }}
                >
                  <div
                    role="modal-header"
                    className="singleQuoteMainPrimaryFilesTitle"
                    style={{ 
                      marginTop: 0, 
                      padding: 0,
                      fontSize: '24px',
                      color: '#030F23',
                      lineHeight: '140%',
                      letterSpacing: '0.24px',
                    }}
                  >
                    <span>Revision Notes</span>
                    <img
                      src={require('../../assets/Cross M.png')}
                      alt="close-icon"
                      className="size-5 cursor-pointer"
                      onClick={() => setOpenRevision(false)}
                    />
                  </div>
                  <div 
                    role="modal-editor-and-buttons" 
                    className="gap-4 singleTranslationNotesContainer no-scrollbar"
                    style={{marginBottom: 0, overflow: 'inherit'}}
                  >
                    <span className="yourNotesText">Your notes</span>

                    <div
                      className="p-2 flex flex-col no-scrollbar "
                      style={{ 
                        overflow : 'visible',
                        borderRadius:'6px', 
                        gap:'6px', 
                        width: '100%',
                        maxHeight: '200px',
                        minHeight : '200px',
                        border: `1px solid ${!hasEditorContent || isAttachment || isEditorFocused
                        ? 'black' 
                        : 'var(--Grey-Colors-Grey-10, #E6E7E9)'}` 
                        
                      }}
                    >
                      <div role="format-buttons" className="revisionSingleOrderTextButtons">
                        <div className="relative">
                          <BOLD 
                            className="revisionSingleOrderRichTextButton" 
                            onMouseDown={(e) => {
                              e.preventDefault();
                              handleBoldClick(true);
                            }} 
                            style={{
                              color: currentStyle.has('BOLD') ? '#12ABBF' : '#2D3643',
                              border: currentStyle.has('BOLD') ? '1px solid #12ABBF' : '1px solid transparent',
                              borderRadius: '4px',
                            }}                        
                          />
                          <Tooltip text='Bold' letter='B' />
                        </div>
                        <div className="relative">
                          <ITALIC 
                            className="revisionSingleOrderRichTextButton" 
                            onMouseDown={(e) => {
                              e.preventDefault();
                              handleItalicClick(true);
                            }} 
                            style={{
                              color: currentStyle.has('ITALIC') ? '#12ABBF' : '#2D3643',
                              border: currentStyle.has('ITALIC') ? '1px solid #12ABBF' : '1px solid transparent',
                              borderRadius: '4px',
                            }} 
                          />
                          <Tooltip text='Italic' letter='I' />
                        </div>
                        <div className="relative">
                          <UNDERLINE 
                            className="revisionSingleOrderRichTextButton" 
                            onMouseDown={(e) => {
                              e.preventDefault();
                              handleUnderlineClick(true);
                            }} 
                            style={{
                              color: currentStyle.has('UNDERLINE') ? '#12ABBF' : '#2D3643',
                              border: currentStyle.has('UNDERLINE') ? '1px solid #12ABBF' : '1px solid transparent',
                              borderRadius: '4px',
                            }} 
                          />
                          <Tooltip text='Underline' letter='U' />
                        </div>
                        <div className="relative">
                          <STRIKETHROUGH 
                            className="revisionSingleOrderRichTextButton" 
                            onMouseDown={(e) => {
                              e.preventDefault();
                              handleStrikethroughClick(true);
                            }} 
                            style={{
                              color: currentStyle.has('STRIKETHROUGH') ? '#12ABBF' : '#2D3643',
                              border: currentStyle.has('STRIKETHROUGH') ? '1px solid #12ABBF' : '1px solid transparent',
                              borderRadius: '4px',
                            }} 
                          />
                          <Tooltip text="Strikethrough" letter="Shift + X" width='120'/>
                        </div>
                        <div className="relative">
                          <NUMBERLIST 
                            className="revisionSingleOrderRichTextButton" 
                            onMouseDown={(e) => {
                              e.preventDefault();
                              toggleOL(true);
                            }} 
                            style={{
                              color: blockType === 'ordered-list-item' ? '#12ABBF' : '#2D3643',
                              border: blockType === 'ordered-list-item' ? '1px solid #12ABBF' : '1px solid transparent',
                              borderRadius: '4px',
                            }} 
                          />
                          <Tooltip text="Numbered List" letter="Shift + 7" width='120'/>
                        </div>
                        <div className="relative">
                          <BULLETEDLIST 
                            className="revisionSingleOrderRichTextButton" 
                            onMouseDown={(e) => {
                              e.preventDefault();
                              toggleUL(true);
                            }}
                            style={{
                              color: blockType === 'unordered-list-item' ? '#12ABBF' : '#2D3643',
                              border: blockType === 'unordered-list-item' ? '1px solid #12ABBF' : '1px solid transparent',
                              borderRadius: '4px',
                            }}  
                          />
                          <Tooltip text="Bulleted List" letter="Shift + 8" width='120'/>
                        </div>
                        <div className="relative">
                          <ATTACHMENT 
                            className="revisionSingleOrderRichTextButton" 
                            onMouseDown={(e) => {
                              e.preventDefault();
                              setIsAttachment(true);
                            }} 
                            style={{
                              color: isAttachment ? '#12ABBF' : '#2D3643',
                              border: isAttachment ? '1px solid #12ABBF' : '1px solid transparent',
                            }} 
                          />
                          <Tooltip text="Please upload file(s) to submit revision" width='180' icon={false}/>
                        </div>
                      </div>
                      <div role="editor" style={{border:'none'}} className="singleTranslationRichTextEditor">
                        <Editor
                          ref={editorRef}
                          editorState={clientRevisionNotes}
                          onChange={setClientRevisionNotes}
                          blockRenderMap={blockRenderMap}
                          placeholder={hasEditorContent ? "Message" : ""}
                          onFocus={() => setIsEditorFocused(true)}
                          onBlur={() => setIsEditorFocused(false)}
                          handleKeyCommand={handleKeyCommand}
                          keyBindingFn={keyBindingFn}
                        />
                      </div>
                    </div> 

                    {files.length > 0 && (
                      <div className="fileListContainer w-full flex flex-col gap-3 h-[300px] min-h-[80px] overflow-auto">
                      {[...files]
                        .sort((a, b) => b.timestamp - a.timestamp)
                        .map((file, index, sortedFiles) => (
                          <div 
                            key={file.id}
                            className="fileUploaderLineOuter"
                            style={{
                              gap:'4px',
                              height: file?.error ? '45px' : 'auto',
                              ...(sortedFiles.length >= 2 && index > 0
                                  ? { borderTop: "1px solid var(--Grey-Colors-Grey-10, #E6E7E9)", paddingTop: "12px" }
                                  : {})
                            }}
                          >
                            <div className="fileUploaderLine">
                              <div className="fileUploaderLineInfo" style={{gap:'12px'}}>
                                <GetFileTypeElement file={file}/>
                                <p
                                  className="fileUploaderLineName"
                                  style={{ maxWidth: "100%" }}
                                >
                                  {file.name}
                                </p>
                              </div>

                              <div className="flex md:w-1/2 w-full md:gap-4 md:justify-end justify-around items-center">
                                {/* {file.status !== "uploading" &&
                                  file.timestamp && (
                                    <p className="fileUploaderLineSize">
                                      {formatDateFile(file.timestamp)}
                                    </p>
                                )} */}

                                {file.status === "uploading" ? (
                                  <>
                                    <div className="fileUploaderLineProgressContainer">
                                      <animated.div
                                        style={{
                                          width: `${file.progress}%`,
                                          borderRadius: '60px',
                                          borderBottomWidth: '7px'
                                        }}
                                        className="fileUploaderLineProgress"
                                      />
                                    </div>
                                    <span className="fileProgress">
                                      {Math.round(file.progress)}%
                                    </span>
                                  </>
                                ) : null}

                                {file.status === "uploading" && (
                                  <Cross
                                    className="fileUploaderLineIcon"
                                    onClick={() => handleDeleteFile(file)}
                                  />
                                )}
                                {file.status !== "uploading" && (
                                  <Trash
                                    className="fileUploaderLineIcon"
                                    onClick={() => handleDeleteFile(file)}
                                  />
                                )}

                                {/* {file.status === "complete" && (
                                  <DOWNLOAD
                                    className="hardCopyAddressIcon"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => handleDownloadFile(file, showNotification)}
                                  />
                                )} */}
                              </div>
                            </div>
                            {file.file.error && (
                              <>
                                <div 
                                style={{
                                  background: 'var(--Other-Red, #D70015)',
                                  width:'100%', 
                                  height:'1px',
                                  marginLeft: '70px'
                                }}
                                />
                                <p className="fileErrorMessage">
                                  {file.file.error || "This is an error"}
                                </p>
                              </>
                            )}
                          </div>
                        ))}
                      </div>
                    )}   
                  </div>
                </div>

                {isAttachment && (
                  <div
                    className="absolute inset-0 z-50 flex items-center justify-center bg-transparent"
                    onClick={(e) => { setIsAttachment(false);}}
                  >
                    <div 
                      className="uploadFileModal"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <div 
                        className="singleQuoteMainPrimaryFilesTitle" 
                        style={{fontSize:'16px', padding:'0', color: '#030F23'}}
                      >
                        Upload Files
                      </div>
                      {orderInfo && orderInfo?.files && (
                        <div style={{margin: '0'}} className="quoteDetailsFileUploaderContainer">
                          <FileUploaderButton
                            text="Add Files"
                            files={files}
                            handleFiles={(e) => {
                              handleFiles(e);
                              setIsAttachment(false);
                            }}
                            handleDeleteFile={handleDeleteFile}
                            display={false}
                            multiple={true}
                            hideUploadBox={false}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                )}             
                
                <div className="singleOrderRevisionButtons w-full" style={{ gap: '8px', width:'100%' }}>
                  <NewButton
                    width="100%"
                    back={true}
                    whiteBtn={true}
                    text={orderInfo?.status === 'revision' ? "Close" : "Cancel"}
                    onClick={() => setOpenRevision(false)}
                    backend
                    icon={false}
                  />
                  <NewButton
                    width="100%"
                    back={false}
                    whiteBtn={true}
                    text="Save"
                    onClick={submitRevisionRequest}
                    backend
                    disabled={isDisabled}
                    className={`
                      ${isDisabled ? "bg-[#B3E4EB] cursor-not-allowed" : "cursor-pointer"}`}
                  />
                </div>
              </div>
            </div>
          )}
          <AccountNavBar
            windowSize={windowSize}
            selectedTab={"orders"}
            accountMainPadding={false}
            bgTransparent={true}
            breadLinkType="order"
            breadLink={`Order #${orderInfo ? (orderInfo.orderNumber) : ""
              }`}
          >
            {!loadedOrder && (
              <NoData
                loadingText="order"
                type="order"
                loading={true}
                showBtn={false}
              />
            )}

            {loadedOrder && (
              <div className="mainOrderPageContainer">
                <div className="mainOrderTitleWrapper">
                  <h2 className="createOrderNavbarMenuTitle">
                  {orderInfo.sample ? <span className="text-[#9A9FA7]">Sample</span> : ""} Order #{(orderInfo.orderNumber)}
                  </h2>
                  <div className="mainOrderStatusWrap">
                    {showStatusHoverBox ? (
                      <div className="mainOrderStatusHover">
                        <p className="title">
                          Status:{" "}
                          {orderInfo.cancellationHold && orderInfo.status === "on-hold" ? ORDERSTATUS["cancel-hold"][0] : ORDERSTATUS[orderInfo.status.toLowerCase()][0]}
                        </p>
                        <p className="subTitle">
                          {orderInfo.cancellationHold && orderInfo.status === "on-hold" ? ORDERSTATUS["cancel-hold"][2] : ORDERSTATUS[orderInfo.status.toLowerCase()][2]}
                        </p>
                      </div>
                    ) : null}
                    <div
                      className="mainOrderOrderStatus"
                      style={{
                        backgroundColor: orderInfo.cancellationHold && orderInfo.status === "on-hold" ? ORDERSTATUS["cancel-hold"][1] :ORDERSTATUS[orderInfo.status] ? ORDERSTATUS[orderInfo.status][1] : "",
                      }}
                      onMouseOver={() => setShowStatusHoverBox(true)}
                      onMouseOut={() => setShowStatusHoverBox(false)}
                    >
                      {orderInfo.cancellationHold && orderInfo.status === "on-hold" ? ORDERSTATUS["cancel-hold"][0] : ORDERSTATUS[orderInfo.status]
                        ? ORDERSTATUS[orderInfo.status][0]
                        : orderInfo.status}
                      <Info className="statusIcon" />
                    </div>
                  </div>
                </div>
                <div className="mainOrderSecondaryContent mainOrderTransBtnWrap">
                  {/* {userData &&
                    userData.id === orderInfo.userID &&
                    orderInfo &&
                    orderInfo.status === "user-review" &&
                    orderInfo.supportApproved && (
                      <NewButton
                        text={"Approve Translation"}
                        width={"100%"}
                        customIcon={<LIKE />}
                        smallPadding
                        onClick={() => setShowApproveTranslation(true)}
                      />
                    )} */}
                  {orderInfo.status !== "created" && (
                    <NewButton
                      text={"View Invoice"}
                      back
                      whiteBtn
                      width={windowSize.width < 1025 ? "100%" : "100px"}
                      icon={false}
                      smallPadding
                      onClick={() => handleDownloadOrder(orderInfo)}
                    />
                  )}
                  {userData &&
                    (userData.id === orderInfo.userID || (userData.teamId && userData.teamId === orderInfo.teamId) || userData.role !== "client") &&
                    (orderInfo.status === "new" ||
                      orderInfo.status === "in-porgress" ||
                      orderInfo.status === "assigned") && (
                      <NewButton
                        text={"Cancel"}
                        customIcon={<TRASH />}
                        back
                        whiteBtn
                        width={windowSize.width < 1025 ? "100%" : "100px"}
                        smallPadding
                        onClick={() => setShowCancelOrder(true)}
                      />
                    )}
                </div>
              </div>
            )}
            {loadedOrder && (
              <div className="mainOrderPageContainer">
                <div className="mainOrderPageContainerOptions">
                  <div id="mainPrimary" className="mainOrderPrimaryContent">
                    <div className="accountSettingsMenu mainOrderTabMenu grid-cols-3">
                      <div
                        className="accountSettingsMenuTab"
                        onClick={() => setSelectedTab(0)}
                      >
                        <div className="accountSettingMenuTextWrap">
                          <p
                            className={`accountSettingMenuText ${selectedTab === 0 && "selectedTab"
                              }`}
                          >
                            Order Info
                          </p>
                        </div>
                        <div className="accountSettingsMenuSpacer">
                          <div></div>
                        </div>
                      </div>
                      <div
                        className="accountSettingsMenuTab"
                        onClick={() => setSelectedTab(1)}
                      >
                        <div className="accountSettingMenuTextWrap">
                          <p
                            className={`accountSettingMenuText ${selectedTab === 1 && "selectedTab"
                              }`}
                          >
                            Files
                          </p>
                        </div>
                        <div className="accountSettingsMenuSpacer">
                          <div></div>
                        </div>
                      </div>
                      <div
                        className="accountSettingsMenuTab"
                        onClick={() => (!userData ? setIsModalOpen(true) : setSelectedTab(2))}
                      >
                        <div className="accountSettingMenuTextWrap">
                          <p
                            className={`accountSettingMenuText ${selectedTab === 2 && "selectedTab"
                              }`}
                          >
                            General Chat
                          </p>
                          {selectedTab !== 2 && <MessageDot chatId={orderInfo.generalChatId}/>}
                        </div>
                      </div>
                    </div>
                    {selectedTab === 0 && (
                      <div className="quotePrimaryOptionsWrapper accSingleQuoteDataWrapper">
                        <div className="accSingleQuoteDataWrap">
                          <div className="accSingleQuoteDataContainer">
                            <h6 className="accSingleQuoteTitle">Order Info</h6>
                            <p className="accSingleInvoiceText accSingleInvoiceSubText">
                              Date
                            </p>
                            <p className="accSingleInvoiceText">
                              {formatDate(orderInfo.timestamp)}
                            </p>
                          </div>
                          <div className="accSingleQuoteDataContainer">
                            <p></p>
                            <p className="accSingleInvoiceText accSingleInvoiceSubText">
                              Language
                            </p>
                            <p className="accSingleInvoiceText">
                              {getLanguage(orderInfo.languageFrom)}{" "}
                              {getLanguage(orderInfo.languageTo)}
                            </p>
                          </div>
                        </div>
                        <div className="accSingleQuoteDataWrap">
                          <div className="accSingleQuoteDataContainer">
                            <h6 className="accSingleQuoteTitle">Contact</h6>
                            <p className="accSingleInvoiceText accSingleInvoiceSubText">
                              Name
                            </p>
                            <p className="accSingleInvoiceText capital">
                              {orderInfo.name}
                            </p>
                          </div>
                          <div className="accSingleQuoteDataContainer">
                            <p></p>
                            <p className="accSingleInvoiceText accSingleInvoiceSubText">
                              Email
                            </p>
                            <p className="accSingleInvoiceText">
                              {orderInfo.email}
                            </p>
                          </div>
                        </div>
                        <div className="accSingleQuoteDataWrap">
                          <div className="accSingleQuoteDataContainer">
                            <h6 className="accSingleQuoteTitle">Services</h6>
                            
                            { !orderInfo.hardCopy && !orderInfo.notarization && !(orderInfo.expedited || orderInfo.expeditedPlus) 
                            && (
                                <p className="accSingleInvoiceText accSingleInvoiceSubText">
                                  No Additional Services Available
                                </p>
                            )}
                           
                          </div>

                          {(orderInfo.expeditedPlus || orderInfo.expedited) && (
                              <div className="accSingleQuoteDataContainer">
                                <p></p>
                                <p className="accSingleInvoiceText accSingleInvoiceSubText">
                                  {orderInfo.expeditedPlus ? "Expedited+" : "Expedited"} Turnaround
                                </p>
                                <p className="accSingleInvoiceText">
                                  <CHECK />
                                </p>
                              </div>
                            )}

                          {orderInfo.notarization && (
                              <div className="accSingleQuoteDataContainer">
                                <p></p>
                                <p className="accSingleInvoiceText accSingleInvoiceSubText">
                                  Notarization
                                </p>
                                <p className="accSingleInvoiceText">
                                  <CHECK />
                                </p>
                              </div>
                            )}

                          {orderInfo.hardCopy &&  (
                              <div className="accSingleQuoteDataContainer">
                                <p></p>
                                <p className="accSingleInvoiceText accSingleInvoiceSubText">
                                  Mail Hard Copy
                                </p>
                                <p className="accSingleInvoiceText capital">
                                  {getFullAddress(orderInfo.hardCopyExtra)}<br/><span className="font-[600]">{orderInfo.hardCopyExtra.method ? " (USPS " + orderInfo.hardCopyExtra.method + (orderInfo.hardCopyExtra.requireSignature ? " - required signature" :"") + ")" : ""}</span>
                                  {
                                  orderInfo.status === "completed" && orderInfo.hardCopyStatus && orderInfo.hardCopyTrackingID && (
                                    <div className="flex flex-col">
                                      
                                      <div className="flex items-center mt-2 mb-1">
                                         <p className="accSingleInvoiceText">
                                            <CHECK />
                                          </p>
                                          Shipped
                                      </div>

                                      <FormTextInput
                                        placeholder="Tracking ID"
                                        value={orderInfo.hardCopyTrackingID}
                                        disabled={true}

                                      />
                                    </div>
                                  )
                                }
                                </p>
                                
                              </div>
                            )}

                        </div>
                      </div>
                    )}

                    {selectedTab === 0 && orderInfo.notes && (
                      <div className="quotePrimaryOptionsWrapper">
                        <h4 className="quotePrimaryTitle">General Notes</h4>
                        {orderInfo.notes && orderInfo.notes.blocks ? (
                          editorState.getCurrentContent().getPlainText() !==
                          "" && (
                            <div className="accSingleInvoiceText">
                              <Editor
                                editorState={editorState}
                                onChange={(editorState) =>
                                  setEditorState(editorState)
                                }
                                readOnly
                              />
                            </div>
                          )
                        ) : (
                          <p className="accSingleInvoiceText">
                            {orderInfo.notes
                              ? orderInfo.notes
                              : orderInfo.clientNotes}
                          </p>
                        )}
                      </div>
                    )}

                    {(selectedTab === 0 && (!userData ? orderInfo.clientFirstName : true)  
                    && ((orderInfo.type && orderInfo.type === "business") || orderInfo.teamId)) && (
                      <div className="quotePrimaryOptionsWrapper">
                        <h4 className="quotePrimaryTitle mb-1">
                          Your Client <span>{"(optional)"}</span>
                        </h4>

                        <h6 className="accSingleInvoiceText accSingleInvoiceSubText">
                          If submitted, the client field will be included in
                          emails, in translations, and in your invoice.
                        </h6>

                        <div className="accSingleOrderCCEmailWrap">
                          <FormTextInput
                            placeholder="Client First Name"
                            value={clientFirstName}
                            onChange={setClientFirstName}
                            onKeyDown={(e) =>
                              e.key === "Enter" &&
                              handleSaveClientName()
                            }
                            disabled={!(userData && (( userData.teamId && orderInfo.teamId && userData.teamId === orderInfo.teamId) || userData.role !== "client"))}
                          />
                          <FormTextInput
                            placeholder="Client Last Name"
                            value={clientLastName}
                            onChange={setClientLastName}
                            onKeyDown={(e) =>
                              e.key === "Enter" &&
                              handleSaveClientName()
                            }
                            disabled={!(userData && (( userData.teamId && orderInfo.teamId && userData.teamId === orderInfo.teamId) || userData.role !== "client"))}
                          />
                          <NewButton
                            width="86px"
                            text={saveClientBtnTxt}
                            back
                            whiteBtn
                            icon={false}
                            onClick={() => {
                              handleSaveClientName();
                            }}
                            disabled={
                              clientFirstName === "" ||
                              saveClientBtnTxt === "Saving.." || 
                              !(userData && (( userData.teamId && orderInfo.teamId && userData.teamId === orderInfo.teamId) || userData.role !== "client"))
                            }
                          />
                        </div>
                      </div>
                    )}

                    {/* TODO: Unncomment CC-order */}
                    {/* {selectedTab === 0 && (
                      <div className="quotePrimaryOptionsWrapper">
                        <h4 className="quotePrimaryTitle">
                          CC{"'"}ed to This Order
                        </h4>
                        <h6 className="accSingleInvoiceText accSingleInvoiceSubText">
                          All added people will receive email notifications
                          about the details of the order, its updates, and will
                          be able to download the translation.
                        </h6>

                        {userData && userData.id === orderInfo.userID && (
                          <div className="accSingleOrderCCEmailWrap">
                            <FormTextInput
                              placeholder="User's email"
                              value={newCCEmail}
                              onChange={setNewCCEmail}
                              onKeyDown={(e) =>
                                e.key === "Enter" && addCCedEmail(newCCEmail)
                              }
                            />
                            <NewButton
                              width="86px"
                              text={addCCEmailBtnTxt}
                              back
                              whiteBtn
                              icon={false}
                              onClick={() => {
                                addCCedEmail();
                              }}
                              disabled={
                                newCCEmail === "" ||
                                addCCEmailBtnTxt === "Adding.."
                              }
                            />
                          </div>
                        )}

                        {newCCEmail !== "" && (
                          <div className="accSingleOrderTeamUsers">
                            {teamUsers
                              .filter(
                                (u) =>
                                  u.email.includes(newCCEmail) &&
                                  ccedEmails.length > 0 &&
                                  !ccedEmails.includes(u.email)
                              )
                              .map((user) => (
                                <p
                                  className="accSingleInvoiceText"
                                  onClick={() => addCCedEmail(user.email)}
                                >
                                  {user.email}
                                </p>
                              ))}
                          </div>
                        )}

                        {ccedEmails.map((email) => (
                          <div className="accSingleOrderCCEmails">
                            <p className="accSingleInvoiceText">{email}</p>
                            {userData && userData.id === orderInfo.userID && (
                              <CROSS
                                onClick={() => removeCCedEmail(email)}
                                className="accSingleOrderOrderCCRemoveIcon"
                              />
                            )}
                          </div>
                        ))}
                      </div>
                    )} */}


                    {selectedTab === 0 && orderInfo.status === "completed" && (
                      <div className="quotePrimaryOptionsWrapper">
                        {orderInfo.reviewRating ? (
                          <div className="accSingleOrderMoreBtnWrap">
                            <h4 className="quotePrimaryTitle">Your Review</h4>
                            {userData &&
                              userData.id === orderInfo.userID &&
                              !editReview && (
                                <div
                                  className="hardCopyAddressIconWrap"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setMoreOptions((prev) =>
                                      prev ? false : true
                                    );
                                  }}
                                  tabIndex={0}
                                  onBlur={() => setMoreOptions(false)}
                                >
                                  {moreOptions ? (
                                    <MORESELECTED className="hardCopyAddressIcon" />
                                  ) : (
                                    <MORE
                                      className="hardCopyAddressIcon"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setMoreOptions((prev) =>
                                          prev ? false : true
                                        );
                                      }}
                                    />
                                  )}

                                  {moreOptions && (
                                    <div className="hardCopyAddressEditWrap">
                                      <div
                                        className="hardCopyAddressEdit"
                                        onClick={() => {
                                          setEditReview(true);
                                          setReviewRating(
                                            orderInfo.reviewRating
                                          );
                                          setReviewText(orderInfo.reviewText);
                                          setMoreOptions(false);
                                        }}
                                      >
                                        Edit Review
                                      </div>
                                      <div
                                        className="hardCopyAddressEdit"
                                        onClick={() => {
                                          setShowDeleteReview(true);
                                          setMoreOptions(false);
                                        }}
                                      >
                                        Delete Review
                                      </div>
                                    </div>
                                  )}
                                </div>
                              )}
                          </div>
                        ) : (
                          <h4 className="quotePrimaryTitle mb-1">Leave a Review</h4>
                        )}
                        {!orderInfo.reviewRating && (
                          <>
                            <h6 className="accSingleInvoiceText accSingleInvoiceSubText">
                              Rate the quality of the translation, additional
                              services and communication with the interpreter, if
                              any.
                            </h6>
                          </>
                        )}
                        {orderInfo.reviewRating && !editReview ? (
                          <div
                            className="accSingleOrderReviewWrap"
                            style={{ marginTop: "8px" }}
                          >
                            <div className="accSingleOrderStarWrap">
                              <EMPTYSTAR
                                className={`accSingleOrderStar ${orderInfo.reviewRating > 0
                                  ? "accSingleOrderStarSelected"
                                  : ""
                                  }`} 
                              />
                              <EMPTYSTAR
                                className={`accSingleOrderStar ${orderInfo.reviewRating > 1
                                  ? "accSingleOrderStarSelected"
                                  : ""
                                  }`}
                              />
                              <EMPTYSTAR
                                className={`accSingleOrderStar ${orderInfo.reviewRating > 2
                                  ? "accSingleOrderStarSelected"
                                  : ""
                                  }`}
                              />
                              <EMPTYSTAR
                                className={`accSingleOrderStar ${orderInfo.reviewRating > 3
                                  ? "accSingleOrderStarSelected"
                                  : ""
                                  }`}
                              />
                              <EMPTYSTAR
                                className={`accSingleOrderStar ${orderInfo.reviewRating > 4
                                  ? "accSingleOrderStarSelected"
                                  : ""
                                  }`}
                              />
                            </div>
                            {orderInfo.reviewText && !editReview && (
                              <p className="accSingleInvoiceText">
                                {orderInfo.reviewText}
                              </p>
                            )}
                            {/* <NewButton text="Edit Review" onClick={() => setShowReviewPopUp(true)} smallPadding={true}/> */}
                          </div>
                        ) : (
                          userData &&
                          (userData.id === orderInfo.userID || (userData && userData.teamId && orderInfo.teamId && userData.teamId === orderInfo.teamId)) && (
                            <div
                              className="accSingleOrderReviewWrap"
                              style={{ marginTop: editReview ? 0 : "1rem" }}
                            >
                              {!orderInfo.reviewRating && (
                                <p className="accSingleInvoiceText">
                                  How did we do?
                                </p>
                              )}
                              <div className="accSingleOrderStarWrap">
                                <EMPTYSTAR
                                  className={`accSingleOrderStar ${reviewRating > 0
                                    ? "accSingleOrderStarSelected"
                                    : ""
                                    }`}
                                  onMouseOver={() => setReviewRating(1)}
                                  onClick={() => setReviewRating(1)}
                                />
                                <EMPTYSTAR
                                  className={`accSingleOrderStar ${reviewRating > 1
                                    ? "accSingleOrderStarSelected"
                                    : ""
                                    }`}
                                  onMouseOver={() => setReviewRating(2)}
                                  onClick={() => setReviewRating(2)}
                                />
                                <EMPTYSTAR
                                  className={`accSingleOrderStar ${reviewRating > 2
                                    ? "accSingleOrderStarSelected"
                                    : ""
                                    }`}
                                  onMouseOver={() => setReviewRating(3)}
                                  onClick={() => setReviewRating(3)}
                                />
                                <EMPTYSTAR
                                  className={`accSingleOrderStar ${reviewRating > 3
                                    ? "accSingleOrderStarSelected"
                                    : ""
                                    }`}
                                  onMouseOver={() => setReviewRating(4)}
                                  onClick={() => setReviewRating(4)}
                                />
                                <EMPTYSTAR
                                  className={`accSingleOrderStar ${reviewRating > 4
                                    ? "accSingleOrderStarSelected"
                                    : ""
                                    }`}
                                  onMouseOver={() => setReviewRating(5)}
                                  onClick={() => setReviewRating(5)}
                                />
                              </div>
                              <FormTextArea
                                placeholder="Review (optional)"
                                value={reviewText}
                                onChange={setReviewText}
                              />
                              {!orderInfo.reviewRating && (
                                <NewButton
                                  width="86px"
                                  text={reviewSubmitButton}
                                  back
                                  whiteBtn
                                  icon={false}
                                  onClick={() => {
                                    handleSubmitReview();
                                  }}
                                  disabled={
                                    reviewRating === 0 ||
                                    reviewSubmitButton === "Submitting..."
                                  }
                                />
                              )}
                              {editReview && orderInfo.reviewRating && (
                                <div className="accSingleOrderUpdateReviewBtnWrap">
                                  <NewButton
                                    smallPadding
                                    width="86px"
                                    text={saveReviewBtn}
                                    onClick={() => {
                                      handleUpdateReview();
                                    }}
                                    disabled={
                                      reviewRating === 0 ||
                                      saveReviewBtn === "Saving..."
                                    }
                                  />
                                  <NewButton
                                    smallPadding
                                    width="86px"
                                    text={"Cancel"}
                                    back
                                    whiteBtn
                                    icon={false}
                                    onClick={() => {
                                      setEditReview(false);
                                    }}
                                  />
                                </div>
                              )}
                            </div>
                          )
                        )}
                      </div>
                    )}

                    {
                      selectedTab === 0 && 
                      (supportReplyNotes.getCurrentContent().getPlainText() !== ''
                          || clientRevisionNotesFinal.getCurrentContent().getPlainText() !== ''
                          || (orderInfo && (orderInfo.status === 'user-review' || orderInfo.status === 'completed') && translatorNotesClient.getCurrentContent().getPlainText() !== ''))
                      &&
                      <div className="quotePrimaryOptionsWrapper">
                        {orderInfo && <div className="quotePrimaryTitle mb-2.5">Notes</div>}
                        {supportReplyNotes.getCurrentContent().getPlainText() !== '' && <div className="singleTranslationNotesContainer">
                          <div className="singleTranslationNotesTitle border-none bg-transparent text-black pl-0 font-medium"><strong>Support's Notes</strong></div>
                          <div style={{ borderRadius: '6px' }} className="singleTranslationRichTextEditor no-scrollbar">
                            <Editor
                              editorState={supportReplyNotes}
                              onChange={supportReplyNotes => setSupportReplyNotes(supportReplyNotes)}
                              readOnly
                            />
                          </div>
                        </div>}
                        {clientRevisionNotesFinal.getCurrentContent().getPlainText() !== '' && <div className="singleTranslationNotesContainer">
                          <div className="singleTranslationNotesTitle border-none bg-transparent text-black pl-0 font-medium"><strong>Client's Revision Notes</strong></div>
                          <div style={{ borderRadius: '6px' }} className="singleTranslationRichTextEditor no-scrollbar">
                            <Editor
                              editorState={clientRevisionNotesFinal}
                              onChange={clientRevisionNotesFinal => setClientRevisionNotesFinal(clientRevisionNotesFinal)}
                              readOnly
                            />
                          </div>
                        </div>}
                        {orderInfo && (orderInfo.status === 'user-review' || orderInfo.status === 'completed') && translatorNotesClient.getCurrentContent().getPlainText() !== '' &&
                          <div className="singleTranslationNotesContainer">
                            <div className="singleTranslationNotesTitle border-none bg-transparent text-black pl-0 font-medium">
                              <strong>Translator Revision Notes</strong>
                            </div>
                            <div style={{ borderRadius: '6px' }} className="singleTranslationRichTextEditor no-scrollbar">
                              <Editor
                                editorState={translatorNotesClient}
                                onChange={translatorNotesClient => setTranslatorNotesClient(translatorNotesClient)}
                                readOnly
                              />
                            </div>
                          </div>
                        }
                      </div>
                    }


                    {selectedTab === 1 &&
                      orderInfo &&
                      (orderInfo.status === "user-review" ||
                        orderInfo.status === "revision" ||
                        orderInfo.status === "support-review" ||
                        orderInfo.status === "cancelled" ||
                        orderInfo.status === "completed") &&
                      orderInfo.supportApproved &&
                      orderInfo.files.filter(
                        (f) => f.type === "translation" || f.type === "revision"
                      ).length > 0 && (
                        <div className="quotePrimaryOptionsWrapper">
                          <h4 className="quotePrimaryTitle">
                            Translated Files
                          </h4>
                          <div className="accSingleQuoteFileWrap">
                            {orderInfo.files
                              .filter(
                                (f) =>
                                  (f.type === "translation" && (f.orderStatus ? f.orderStatus === "revision" ? false : true : true)
                                    //  ||
                                    // (f.type === "revision" &&
                                    //   (orderInfo.status === "user-review" || orderInfo.status === "revision" ||
                                    //     orderInfo.status === "completed"))
                                      ) && (f.format === 'application/pdf' )
                              )
                              .map((file, index) => (
                                <>
                                  <div
                                    key={index}
                                    className="fileUploaderLineOuter"
                                  >
                                    <div className="fileUploaderLine lg:flex-row flex-col lg:justify-between justify-start">
                                      <div className="fileUploaderLineInfo flex-1 relative">
                                        <GetFileTypeElement file={file}/>   
                                        {file.name &&
                                            file.name.length > 14 &&
                                            showDetailModal === file.ref && (
                                            <div className="accountdetailHoverBox left-[50px] top-full">
                                            <p
                                                className="text-[13px] font-normal leading-normal letter-spacing-[-0.01em]"
                                            >
                                                {file.name}
                                            </p>
                                            </div>
                                          )}                                    
                                        <p
                                          className="fileUploaderLineName w-max"

                                          onMouseOver={() =>
                                            setShowDetailModal(file.ref)
                                          }
                                          onMouseLeave={() => setShowDetailModal("")}
                                        >
                                          {file.name}
                                        </p>

                                        {file.refLabel && file.refLabel.length > 0 &&
                                          <div className="flex flex-row gap-1 max-md:hidden">
                                            {file.refLabel.map((label) => (
                                            <span style={{ backgroundColor: REF_LABELS_COLORS[label] }} className={`accFilesRevisedText capitalize`}>
                                              {label}
                                            </span>
                                            ))}
                                          </div>
                                          }
                                        
                                      </div>

                                      <div className="flex lg:gap-4 lg:justify-end justify-around items-center">
                                        {file.status !== "uploading" &&
                                          file.timestamp && (
                                            <p className="fileUploaderLineSize max-sm:hidden">
                                              {formatDate(file.timestamp)}
                                            </p>
                                          )}

                                        {file.status === "uploading" ? (
                                          <div className="fileUploaderLineProgressContainer">
                                            <div
                                              style={{
                                                width: `${file.progress}%`,
                                              }}
                                              className="fileUploaderLineProgress"
                                            />
                                          </div>
                                        ) : null}
                                        <DOWNLOAD
                                          className="fileUploaderLineIcon"
                                          onClick={() => {
                                            downloadFile(file.url);
                                          }}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  {
                                    <div className="accSingleQuoteFileDivider"></div>
                                  }
                                </>
                              ))}
                          </div>
                        </div>
                      )}

                    {selectedTab === 1 && (
                      <>
                        <div className="quotePrimaryOptionsWrapper">
                          <div className="w-full flex justify-between items-center">

                            <div className="memberOrderStatus">

                              <h4 className="quotePrimaryTitle">Source Files</h4>

                            </div>

                            {signedIn && userData && orderInfo.status !== "completed" &&
                            userData.role === AccountType.OWNER && <div>
                              <NewButton
                                back={true}
                                text={"Add New File"}
                                customIcon={<Plus className="h-4 w-4" />}
                                onClick={() => setShowAddSourcefiles(true)}
                              />
                            </div>}

                          </div>
                          <div className="accSingleQuoteFileWrap">
                            {orderInfo.files
                              .filter(
                                (f) =>
                                  f.type === "source" ||
                                  f.type === "reference" ||
                                  f.type === "client"
                              )
                              .map((file, index) => (
                                <>
                                  <div
                                    key={index}
                                    className="fileUploaderLineOuter"
                                  >
                                    <div className="fileUploaderLine lg:flex-row flex-col">
                                      <div className="fileUploaderLineInfo flex-1 relative">
                                        <GetFileTypeElement file={file}/>
                                        {file.name &&
                                            file.name.length > 14 &&
                                            showDetailModal === file.ref && (
                                            <div className="accountdetailHoverBox left-[50px] top-full">
                                            <p
                                                className="text-[13px] font-normal leading-normal letter-spacing-[-0.01em]"
                                            >
                                                {file.name}
                                            </p>
                                            </div>
                                          )}
                                        <p
                                          className="fileUploaderLineName w-max"
                                          onMouseOver={() =>
                                            setShowDetailModal(file.ref)
                                          }
                                          onMouseLeave={() => setShowDetailModal("")}
                                        >
                                          {file.name}
                                        </p>

                                        {file.refLabel && file.refLabel.length > 0 &&
                                          <div className="flex flex-row gap-1 max-md:hidden">
                                            {file.refLabel.map((label) => (
                                            <span style={{ backgroundColor: REF_LABELS_COLORS[label] }} className={`accFilesRevisedText capitalize`}>
                                              {label}
                                            </span>
                                            ))}
                                          </div>
                                          }
                                      </div>

                                      <div className="flex lg:gap-4 lg:justify-end justify-around items-center">
                                        {file.status !== "uploading" &&
                                          file.timestamp && (
                                            <p className="fileUploaderLineSize max-sm:hidden">
                                              {formatDate(file.timestamp)}
                                            </p>
                                          )}

                                        {file.status === "uploading" ? (
                                          <div className="fileUploaderLineProgressContainer">
                                            <div
                                              style={{
                                                width: `${file.progress}%`,
                                              }}
                                              className="fileUploaderLineProgress"
                                            />
                                          </div>
                                        ) : null}

                                        <DOWNLOAD
                                          className="fileUploaderLineIcon"
                                          onClick={() => {
                                            downloadFile(file.url);
                                          }}
                                        />
                                      </div>
                                   
                                    </div>

                                  </div>
                                  {orderInfo.files.length - 1 !== index && (
                                    <div className="accSingleQuoteFileDivider"></div>
                                  )}
                                </>
                              ))}
                          </div>
                        </div>
                      </>
                    )}

                    {selectedTab === 2 && (
                      <div className="quotePrimaryOptionsWrapper">
                        <OrderChatBox
                          userId={userData.id}
                          userRole={userData.role}
                          orderChatId={orderInfo.generalChatId || null}
                          orderData={orderInfo}
                          userData={userData}
                          disableAutoFocus = {openRevision}
                        />
                      </div>
                    )}
                  </div>
                </div>

                <div className="mainOrderSecondaryContent">
                  <div className="mainOrderSecondaryContentWrap">
                    <div style={{ marginTop: "1rem" }}>

                      {orderInfo &&
                        orderInfo.status === "user-review" &&
                        orderInfo.supportApproved && (
                          <div className="orderSummary">
                            <h2 className="orderSummaryTitle">Translation</h2>
                            {
                              <>
                                <NewButton
                                  text={"Approve Translation"}
                                  width="100%"
                                  customIcon={<LIKE />}
                                  smallPadding
                                  onClick={() => setShowApproveTranslation(true)}
                                />
                                <div className="mt-3"></div>
                                <NewButton
                                  text={"Request Revision"}
                                  onClick={() => setOpenRevision(true)}
                                  whiteBtn
                                  back
                                  icon={false}
                                  width='100%'
                                />
                              </>
                            }
                          </div>
                        )}

                      {
                        orderInfo.status === "revision" && <div className="orderSummary">
                          <h2 className="orderSummaryTitle">Revision Request</h2>

                          {
                            orderInfo.status === "revision" && <>
                              <NewButton
                                text="See Revision Request"
                                onClick={() => setOpenDisplayRevision(true)}
                                icon={false}
                                width='100%'
                              />
                            </>
                          } 
                        </div>
                      }
                      <OrderSummary
                        order={orderInfo}
                        certified={orderInfo.certified}
                        pagesCount={orderInfo.pagesCount}
                        languageFrom={orderInfo.languageFrom}
                        languageTo={orderInfo.languageTo}
                        discount={orderInfo.discount}
                        showBtn={
                          (checkAutoBilling(teamData) && orderInfo.status !== "created") ||
                            orderInfo.status === "cancelled" 
                            ? false
                            : (orderInfo.paypalOrderID &&
                            orderInfo.paypalOrderID === "pay-later" ) || orderInfo.status === "created"
                        }
                        sendPaymentLinkBtn={
                          (checkAutoBilling(teamData) && orderInfo.status !== "created") ||
                            orderInfo.status === "cancelled"
                            ? false
                            : (
                            orderInfo.paypalOrderID &&
                            orderInfo.paypalOrderID === "pay-later") || orderInfo.status === "created"
                        }
                        handleBtnSubmit={(e) => {
                          orderInfo.status === "created" ?
                          setSelectedPayment(orderInfo)
                          : transitionTo(`/make-payment/${orderInfo.orderInvoiceId ? "invoice" :"order"}/${orderInfo.orderInvoiceId ? orderInfo.orderInvoiceId : orderInfo.id}`);
                        }}
                        disableBtn={false}
                        btnText={orderInfo.status === "created" ? "Place Order" : "Pay"}
                        onClickPaymentLink={() => {
                          setSelectedSendPayment(orderInfo);
                        }}
                      />
                    </div>
                    <SecureAndPrivate hideNeedHelp order={orderInfo} />
                  </div>
                </div>
              </div>
            )}
          </AccountNavBar>
          {openDisplayRevision && 
            <div style={revisionModalProps} className="orderRevisionModalBg" onClick={() => setOpenDisplayRevision(false)}>
              <div style={{justifyContent: 'flex-start' , ...revisionModalProps}} className="orderRevisionModalOuter" onClick={(e) => e.stopPropagation()}>
                <div 
                  role="modal-container" 
                  className="flex flex-col gap-5 w-full"
                >
                  <div role="modal-header" className="singleQuoteMainPrimaryFilesTitle" 
                    style={{ 
                      marginTop: 0,
                      padding: 0,
                      fontSize: '24px',
                      color: '#030F23',
                      lineHeight: '140%',
                      letterSpacing: '0.24px', 
                    }}
                  >
                    <span>Revision Notes</span>
                    <img
                      src={require('../../assets/Cross M.png')}
                      alt="close-icon"
                      className="size-5 cursor-pointer"
                      onClick={() => setOpenDisplayRevision(false)}
                    />
                  </div>
                  {clientRevisionNotes.getCurrentContent().getPlainText() !== '' &&
                  <div style={{ gap:'16px', marginBottom: '0px' }} className="singleTranslationNotesContainer">
                    <h2 className="yourNotesText">Client's Revision Notes</h2>
                    <div style={{ borderRadius:'6px', minHeight: '20vh', maxHeight: '200px', overflow: 'auto' }} className="singleTranslationRichTextEditor no-scrollbar clientSeeRevisionRequestFiles">
                      {<Editor editorState={clientRevisionNotes} readOnly />}
                    </div>
                  </div>}
                </div>
               {orderInfo?.files?.some(
                        f => f.type === "revision" && f.status !== "revision_history" ) && <div className="flex flex-col gap-5 w-full">
                  <div className="yourNotesText">Revision Files</div>
                  {orderInfo && orderInfo.files && <div style={{maxHeight: '150px', overflow: 'auto', marginTop: '0px', boxShadow: 'inset 0 -8px 8px -8px rgba(0,0,0,0.1)'}} className="quoteDetailsFileUploaderContainer no-scrollbar clientSeeRevisionRequestFiles">
                      <FileUploaderButton display backend text="Add Files" files={orderInfo.files.filter(f => f.type === 'revision' && f.status !== "revision_history").concat(files)} showDownloadButton={true} />
                    </div>
                  }
                </div>}
              </div>
            </div>
          }
        </>
      )}
    </>


  );
};

export default SingleOrder;
